/**
 * <s-gl-lang> — Glossary EN / 中文 reading switch (snippets/glossary-lang-toggle.liquid).
 * Sets <html data-gl-lang="zh"> for the current page only; every load starts in English (merchant 2026-11-03). CSS in config/styles.css
 * (.gl-zh / .gl-en-swap) does the swap, so every switch on the page stays in sync. Glossary-only: no locale or currency change.
 */
const root = document.documentElement;

const current = () => (root.dataset.glLang === 'zh' ? 'zh' : 'en');

const sync = () => {
  const lang = current();
  for (const btn of document.querySelectorAll('s-gl-lang [data-gl-set]')) {
    btn.setAttribute('aria-pressed', String(btn.dataset.glSet === lang));
  }
};

class SGlLang extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    sync();
    this.addEventListener(
      'click',
      (e) => {
        const btn = e.target instanceof Element ? e.target.closest('[data-gl-set]') : null;
        if (!btn) return;
        const lang = btn.dataset.glSet === 'zh' ? 'zh' : 'en';
        if (lang === 'zh') root.dataset.glLang = 'zh';
        else delete root.dataset.glLang;
        sync();
        document.dispatchEvent(new CustomEvent('gl-lang:change', { detail: { lang } }));
      },
      { signal: this.#ac.signal },
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-gl-lang')) customElements.define('s-gl-lang', SGlLang);
